<template>
  <div
    id="student-admission-detail-board-main"
    :class="!editMode ? 'student-admission-detail-board-main' : ''"
  >
    <div
      v-if="showBoard"
      class="bg-secondary-3 p-4 rounded-lg"
      :class="isMobile && 'h-100'"
    >
      <div v-if="!editMode" class="pb-3">
        <i
          v-if="isAdmissionCoordination || isCoordination"
          class="far fa-check p-2 rounded-circle bg-white text-orange shadow-sm"
        />
        <i
          v-if="isTransfer"
          class="far fa-arrow-circle-right p-2 rounded-circle bg-white text-orange shadow-sm"
        />
        <span
          v-if="isAdmissionCoordination"
          class="font-weight-bold fs-16 text-dark-gray"
        >
          Confirmar Admisión
        </span>
        <span
          v-if="isCoordination"
          class="font-weight-bold fs-16 text-dark-gray"
        >
          Coordinar Servicio
        </span>
        <span v-if="isTransfer" class="font-weight-bold fs-16 text-dark-gray">
          Traslado Interno
        </span>
      </div>
      <div
        v-if="!editMode"
        class="bg-white rounded-lg p-2"
        :class="{ 'col-4': !isOpen }"
      >
        <div class="row py-2">
          <div
            class="col pl-4 d-flex align-items-center"
            :class="{
              'border-right mr-5': isOpen && !isMobile,
            }"
          >
            <div class="d-flex flex-column">
              <span class="color-gray-6 font-weight-normal fs-14">
                Estudiante:
              </span>
              <p class="font-weight-bold fs-16">
                {{ value.fullName }} - {{ value.studentSieId }}
              </p>
            </div>
          </div>

          <div v-if="isOpen" class="col-md-9">
            <div class="row">
              <div class="col-12 col-lg-2">
                <span class="color-gray-6 font-weight-normal fs-14">
                  Edad:
                </span>
                <p class="font-weight-bold fs-16">
                  {{ value.studentAge }} años
                </p>
              </div>
              <div class="col-12 col-lg-2">
                <span class="color-gray-6 font-weight-normal fs-14">
                  Número de Referido:
                </span>
                <p class="font-weight-bold fs-16">
                  {{ value.referralNumber }}
                </p>
              </div>
              <div class="col-12 col-lg">
                <span class="color-gray-6 font-weight-normal fs-14">
                  Código-Escuela:
                </span>
                <p class="font-weight-bold fs-16">{{ value.place }}</p>
              </div>
              <div class="col-12 col-lg">
                <span class="color-gray-6 font-weight-normal fs-14">
                  Impedimento:
                </span>
                <p class="font-weight-bold fs-16">{{ value.impediment }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-2">
                <span class="color-gray-6 font-weight-normal fs-14">
                  Frecuencia:
                </span>
                <p class="font-weight-bold fs-16">{{ value.frequency }}</p>
              </div>
              <div class="col-12 col-lg-2">
                <span class="color-gray-6 font-weight-normal fs-14">
                  Modalidad:
                </span>
                <p class="font-weight-bold fs-16">
                  {{ value.modalityTypeName }}
                </p>
              </div>
              <div class="col-12 col-lg">
                <span class="color-gray-6 font-weight-normal fs-14">
                  Duración:
                </span>
                <p class="font-weight-bold fs-16">{{ value.duration }}</p>
              </div>
              <div
                v-if="(isAdmissionCoordination || isCoordination) && !editMode"
                class="col-12 col-lg d-flex align-items-center"
              >
                <div class="d-flex flex-column">
                  <p
                    class="my-0 rounded-pill p-2 px-3 text-white pointer"
                    :class="{
                      'bg-success': isCompleted,
                      'bg-orange': !isCompleted,
                    }"
                    @click="isOpen = false"
                  >
                    <i
                      class="fa-check-circle pr-1"
                      :class="{
                        fa: isCompleted,
                        far: !isCompleted,
                      }"
                    />
                    {{ spacesQuantity }}/{{ frequencyNumber }}
                  </p>
                </div>
              </div>

              <div v-if="isTransfer && !editMode" class="col-12 col-lg">
                <span class="color-gray-6 font-weight-normal fs-14">
                  Fecha de Efectividad:
                </span>
                <div>
                  <validation-observer ref="requestDateObserver">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-date-picker
                        v-model="requestDate"
                        :custom-error-msg="'La fecha es requerida.'"
                        :error="errors[0]"
                        :max-date="maxDate"
                        :min-date="minDate"
                        @onSelectedDate="
                          (data) => $emit('onSelectedDate', data)
                        "
                      />
                    </validation-provider>
                  </validation-observer>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="col-2 pl-0 d-flex align-items-center">
            <action-button
              i="fas fa-plus-circle"
              variant="outline-success pl-3 pr-3"
              @click="isOpen = true"
            />
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg p-4 mt-4" :class="{ 'd-none': !isOpen }">
        <div v-if="!isRemoving" class="row my-1">
          <div class="col-12 col-lg-6 col-md-6">
            <div class="row">
              <label class="col-lg-8 col-md-6">
                ¿Este servicio sera ofrecido por un practicante/interno?
              </label>
              <custom-radio-group
                v-model="isPractitioner"
                class="col-lg-4 col-md-6"
                field-key="value"
                :is-inline="true"
                name="claimTypes"
                :options="[
                  { value: true, label: 'Sí' },
                  { value: false, label: 'No' },
                ]"
                @input="onisPractitionerChange"
              />
            </div>
          </div>
          <div v-if="isPractitioner" class="col-12 col-lg-3">
            <custom-drop-down
              v-model="practitioner"
              :clearable="false"
              fieldkey="id"
              fieldname="name"
              :options="interns"
              placeholder="Seleccione"
            />
          </div>
        </div>
        <div v-if="editMode && !isRemoving" class="my-1 row">
          <div class="col-12 col-lg-6 col-md-6">
            <div class="row">
              <label class="col-lg-8 col-md-6">
                ¿Desea modificar el horario y día de toda la sesión grupal?
              </label>
              <custom-radio-group
                v-model="isEditModeInGroup"
                class="col-lg-4 col-md-6"
                field-key="value"
                :is-inline="true"
                name="editOptions"
                :options="[
                  { value: true, label: 'Sí' },
                  { value: false, label: 'No' },
                ]"
                @input="onEditModeInGroupChange"
              />
            </div>
          </div>
        </div>
        <div v-if="isRemoving" class="my-1 row">
          <div class="col-12 col-lg-6 col-md-6">
            <div class="row">
              <label class="col-lg-8 col-md-6">
                ¿Desea Eliminar el espacio de toda la sesión grupal?
              </label>
              <custom-radio-group
                v-model="isRemoveModeInGroup"
                class="col-lg-4 col-md-6"
                field-key="value"
                :is-inline="true"
                name="removeOptions"
                :options="[
                  { value: true, label: 'Sí' },
                  { value: false, label: 'No' },
                ]"
                @input="onRemoveModeInGroupChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDatePicker from '@/components/common/form/CustomDatePicker';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { getAdmission as _getAdmision } from '@/modules/shared/studentreferral.api';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import CustomRadioGroup from '@/components/common/CustomRadio';

import { getPractitionersBySpecialist as _getPractitionersBySpecialist } from '@/modules/practitionerIntern/api';
const COMPLETEDFRECUENCYTYPES = Object.freeze({
  ONETIMEPERMONTH: 827,
  TWOTIMESPERMONTH: 846,
  FORTNIGHTLY: 301,
});
export default {
  name: 'StudentAdmissionDetailBoard',
  components: {
    ActionButton,
    CustomDatePicker,
    ValidationProvider,
    ValidationObserver,
    CustomDropDown,
    CustomRadioGroup,
  },
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    editInfo: {
      type: Object,
      default: () => null,
    },
    isTransfer: {
      type: Boolean,
      default: false,
    },
    isAdmissionCoordination: {
      type: Boolean,
      default: false,
    },
    isCoordination: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    specialistId: {
      type: Number,
      default: null,
    },
    isGroupType: {
      type: Boolean,
      default: false,
    },
    isRemoving: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      isOpen: true,
      requestDate: null,
      admission: {},
      isPractitioner: false,
      isEditModeInGroup: false,
      isRemoveModeInGroup: false,
      practitioner: null,
      interns: [],
    };
  },
  computed: {
    showBoard() {
      return (
        this.isGroupType ||
        this.isCoordination ||
        this.isTransfer ||
        this.isAdmissionCoordination
      );
    },
    showOnlyOneDate() {
      let result;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // si la fecha de hoy es mayor a la fecha de efectividad, se muestra el calendario hasta la fecha de hoy
      if (
        today > this.effectiveDateFrom &&
        today - this.effectiveDateFrom != 0
      ) {
        result = false; // muestra mas de un dia
      }
      // si la fecha de hoy es igual a la fecha de efectividad o es menor, se muestra solo un dia
      else {
        result = true;
      }

      return result;
    },
    minDate() {
      if (this.showOnlyOneDate) {
        const date = new Date(this.effectiveDateFrom);
        date.setDate(date.getDate() - 1); // para mostrar 1 sola fecha (la fecha de efectividad)
        return date;
      }

      return this.effectiveDateFrom;
    },
    maxDate() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // si la fecha de hoy es mayor a la fecha de efectividad, se muestra el calendario hasta la fecha de hoy
      return today > this.effectiveDateFrom ? today : this.effectiveDateFrom;
    },
    frequencyNumber() {
      if (!this.value) return null;
      if (this.value.frequencyTypeId == COMPLETEDFRECUENCYTYPES.FORTNIGHTLY) {
        return 2;
      }
      return Number(this.value.frequency.match(/\d/g)?.join(''));
    },
    spacesQuantity() {
      if (!this.value) return null;
      if (
        (this.value.frequencyTypeId ==
          COMPLETEDFRECUENCYTYPES.ONETIMEPERMONTH ||
          this.value.frequencyTypeId ==
            COMPLETEDFRECUENCYTYPES.TWOTIMESPERMONTH ||
          this.value.frequencyTypeId == COMPLETEDFRECUENCYTYPES.FORTNIGHTLY) &&
        this.value.spaces.length == 1
      ) {
        return this.frequencyNumber;
      }
      return this.value.spaces.length;
    },
    isCompleted() {
      return this.frequencyNumber === this.spacesQuantity;
    },
    currentDate() {
      const date = new Date();
      const dateTo = new Date(this.value.effectiveDateTo);
      return date > dateTo ? dateTo : date;
    },
    effectiveDateFrom() {
      const result = this.admission?.dateFrom
        ? new Date(this.admission.dateFrom)
        : new Date();
      result.setHours(0, 0, 0, 0);

      return result;
    },
  },
  watch: {
    value: {
      deep: true,
      handler(newValue) {
        if (this.editMode) {
          if (this.editInfo.practitionerId) {
            this.isPractitioner = true;
            _getPractitionersBySpecialist(
              this.specialistId,
              newValue?.companyId
            ).then((data) => {
              this.interns = data.data;
              var practitioner = this.interns.find(
                (x) => x.id == this.editInfo.practitionerId
              );
              this.practitioner = practitioner;
            });
          }
        }
      },
    },
  },
  async mounted() {
    if (!this.editMode) {
      await this.getAdmissionInfo();
    }
  },
  methods: {
    onEditModeInGroupChange(e) {
      this.$emit('edit-type', e);
    },
    onRemoveModeInGroupChange(e) {
      this.$emit('remove-type', e);
    },
    async onisPractitionerChange() {
      if (this.isPractitioner) {
        var { data } = await _getPractitionersBySpecialist(
          this.specialistId,
          this.value?.companyId
        );
        this.interns = data;
      } else {
        this.interns = [];
        this.practitioner = null;
      }
    },
    async getAdmissionInfo() {
      await _getAdmision(this.value.admissionId).then(
        ({ data }) => (this.admission = data)
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
.student-admission-detail-board-main > div {
  border-left: 5px solid map-get($colors, 'orange');
  height: 370px !important;
}

@media (max-width: 767px) {
  .student-admission-detail-board-main > div {
    height: 100% !important;
  }
}

.pointer {
  cursor: pointer;
}

.fs-14 {
  font-size: 14px;
}

.fs-16 {
  font-size: 16px;
}
.text-dark-gray {
  color: #3f5b60;
}
</style>
